import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { AuthService } from '../../../auth/auth.service';
import { MainLoadingService } from '../services/main-loading.service';

interface SubMenuItem {
  description: string;
  route: string;
}

interface MenuItem {
  title: string;
  icon: string;
  subMenus: SubMenuItem[];
}

@Component({
  selector: 'app-authenticated-layout',
  templateUrl: './authenticated-layout.component.html',
  styleUrl: './authenticated-layout.component.scss',
})
export class AuthenticatedLayoutComponent implements OnInit {
  mainLoading: boolean = false;
  menu: MenuItem[] = [];
  nameUser: string = '';

  constructor(
    private router: Router,
    private authService: AuthService,
    private mainLoadingService: MainLoadingService,
    private cdr: ChangeDetectorRef,
  ) {
    this.generateMenu();
  }

  ngOnInit() {
    this.mainLoadingService.loading.subscribe((loading) => {
      this.mainLoading = loading;
      this.cdr.detectChanges();
    });
    this.getUserInformation();
  }

  getUserInformation() {
    this.nameUser = this.authService.getUsernameFromToken() ?? '';
  }

  private generateMenu() {
    this.menu = [
      {
        title: 'Checkout',
        icon: 'shopping_cart',
        subMenus: [
          {
            description: 'Transações',
            route: '/private/transacao',
          },
        ],
      },
    ];
  }

  goToPage(route: string, sidenav: MatSidenav): void {
    this.router.navigate([route]);
    sidenav.close();
  }

  logout(): void {
    this.authService.logout();
  }

  setMainLoading(loading: boolean): void {
    this.mainLoading = loading;
  }

  goToProfile() {
    this.router.navigate([`/private/profile`]);
  }

  redirectTransactions(): void {
    this.router.navigate([`/private/transacao`]);
  }
}
